/**
 * What a row actually says. Three states, not two: "no recent observation" is a
 * different fact from "confirmed down", and showing either as the other is a lie.
 */
export enum DisplayState {
  Available = 'available',
  Unavailable = 'unavailable',
  Unknown = 'unknown',
}
